// Pre-parsed project metadata - loaded directly as JavaScript (no JSON parsing at runtime)
// This file is the single source of truth for project metadata

export const projectsRaw = [
    {
        year: "2026",
        data: [
            {
                title: "Loop - Terminal Coding Agent",
                url: "https://github.com/notshekhar/loop",
                date: "Jul 11, 2026",
                updated: "Jul 11, 2026",
                type: "ml",
                technologies: [
                    "TypeScript",
                    "Bun",
                    "AI SDK",
                    "LLM",
                    "CLI",
                    "TUI",
                    "SQLite",
                    "MCP",
                ],
                demo: "https://github.com/notshekhar/loop",
                detailSlug: "loop",
                description:
                    "Bring-your-own-model terminal coding agent — multi-provider, session trees, goals, MCP, sandbox, and subagents.",
            },
            {
                title: "Digg - Kubernetes TUI",
                url: "https://github.com/notshekhar/digg",
                date: "Jun 23, 2026",
                updated: "Jun 23, 2026",
                type: "bed",
                technologies: [
                    "TypeScript",
                    "Bun",
                    "Kubernetes",
                    "kubectl",
                    "CLI",
                    "TUI",
                ],
                demo: "https://github.com/notshekhar/digg",
                detailSlug: "digg",
                description:
                    "Lens/k9s-style Kubernetes cockpit for the terminal — browse any resource including CRDs, live events, logs, shell into pods, port-forward, and day-2 actions.",
            },
            {
                title: "Markdown - Terminal Renderer",
                url: "https://github.com/notshekhar/markdown",
                date: "Jun 15, 2026",
                updated: "Jul 11, 2026",
                type: "bed",
                technologies: [
                    "TypeScript",
                    "Bun",
                    "CLI",
                    "TUI",
                    "LaTeX",
                    "Mermaid",
                ],
                demo: "https://github.com/notshekhar/markdown",
                detailSlug: "markdown",
                description:
                    "Render markdown and LaTeX in your terminal with syntax highlighting, math, and mermaid diagrams — plus an interactive folder browser.",
            },
            {
                title: "SQLBot - Talk to Your Databases",
                url: "https://github.com/notshekhar/sqlbot",
                date: "Jan 15, 2026",
                updated: "Aug 2, 2026",
                type: "ml",
                technologies: [
                    "Typescript",
                    "Bun",
                    "React",
                    "LLM",
                    "SQL",
                    "tRPC",
                    "SQLite",
                    "CLI",
                ],
                demo: "https://github.com/notshekhar/sqlbot",
                detailSlug: "sqlbot",
                description:
                    "Ask your database questions in plain English. One binary — Bun server plus React UI, 17 model providers, charts and artifacts, all local.",
            },
        ],
    },
    {
        year: "2025",
        data: [
            {
                title: "Oboe - AI Workspace",
                date: "Dec 23, 2025",
                updated: "Dec 23, 2025",
                type: "ml",
                technologies: [
                    "Bun",
                    "Nextjs",
                    "React",
                    "Typescript",
                    "LLM",
                    "ai-sdk",
                ],
                demo: "https://www.oboe.chat/",
            },
            {
                title: "Boxhead - AI Chat App",
                url: "https://github.com/notshekhar/boxhead",
                date: "June 12, 2025",
                updated: "June 12, 2025",
                type: "ml",
                technologies: [
                    "Nextjs",
                    "ai-sdk",
                    "React",
                    "Typescript",
                    "LLM",
                ],
                demo: "https://www.boxhead.chat",
                detailSlug: "boxhead",
            },
        ],
    },
    {
        year: "2024",
        data: [
            {
                title: "Rain Simulation",
                url: "https://github.com/notshekhar/Rain-Simulation",
                date: "May 27, 2024",
                technologies: ["JavaScript", "Canvas", "HTML"],
                demo: "https://notshekhar.github.io/Rain-Simulation",
                type: "cc",
            },
        ],
    },
    {
        year: 2021,
        data: [
            {
                title: "Simple Paint App",
                url: "https://github.com/notshekhar/Paint-App",
                date: "Oct 24, 2021",
                technologies: ["Javascript", "CSS", "HTML"],
                demo: "https://notshekhar.github.io/Paint-App",
                type: "fed",
            },
            {
                title: "Ticket Booking App",
                url: "https://github.com/notshekhar/ticket_booking",
                date: "Oct 23, 2021",
                technologies: [
                    "Javascript",
                    "node",
                    "Reactjs",
                    "Recoiljs",
                    "CSS",
                    "express",
                    "MongoDB",
                ],
                demo: "https://railway-booking-portal.vercel.app/",
                type: "bed",
            },
            {
                title: "Simple Note Application",
                url: "https://github.com/notshekhar/NoteApp",
                date: "July 12, 2021",
                technologies: [
                    "Javascript",
                    "node",
                    "Reactjs",
                    "Recoiljs",
                    "CSS",
                    "express",
                ],
                demo: "https://notshekhar.github.io/NoteApp",
                type: "bed",
            },
            {
                title: "Simple XML Parser",
                url: "https://github.com/notshekhar/XML-parser",
                date: "July 3, 2021",
                technologies: ["Javascript", "node"],
                demo: "https://www.npmjs.com/package/xmlparser2",
                type: "cc",
            },
            {
                title: "Face, Expression, and Face Landmarks detector",
                url: "https://github.com/notshekhar/Face-Detection",
                date: "June 19, 2021",
                technologies: ["Javascript", "face-api.js"],
                demo: "https://notshekhar.github.io/Face-Detection",
                type: "ml",
            },
            {
                title: "Perceptron.js",
                url: "https://github.com/notshekhar/perceptron.js",
                date: "June 11, 2021",
                technologies: ["Javascript"],
                type: "ml",
            },
            {
                title: "Particle Effect JS",
                url: "https://github.com/notshekhar/particle_effect",
                date: "May 28, 2021",
                technologies: ["HTMLCanvas", "Javascript"],
                demo: "https://notshekhar.github.io/particle_effect",
                type: "cc",
            },
            {
                title: "ToDo App",
                url: "https://github.com/notshekhar/todo-app-using-react-and-recoiljs",
                date: "April 2, 2021",
                technologies: ["React", "Recoiljs", "CSS"],
                demo: "https://brvbd.csb.app/",
                type: "fed",
            },
            {
                title: "P2P File Sharing WebApp",
                url: "https://github.com/notshekhar/P2P-File-Sharing",
                date: "Feb 14, 2021",
                technologies: [
                    "peerjs",
                    "webRTC",
                    "socketio",
                    "express",
                    "ejs",
                    "js",
                    "css",
                    "html",
                ],
                demo: "https://dropall.herokuapp.com",
                type: "bed",
            },
            {
                title: "PaperValut logo",
                url: "https://github.com/notshekhar/LogoDesigns/tree/master/PaperVault",
                date: "Feb 04, 2021",
                technologies: ["Affinity Designer"],
                type: "ld",
            },
            {
                title: "Admit card downloader for GBU(Gautam Buddha University)",
                url: "https://github.com/notshekhar/gbu_admit_card",
                date: "Jan 13, 2021",
                demo: "http://157.245.7.98/",
                technologies: [
                    "JavaScript",
                    "CSS",
                    "HTML",
                    "Nodejs",
                    "Express",
                    "Mysql",
                ],
                type: "bed",
            },
            {
                title: "Drag Drop Image demo",
                url: "https://github.com/notshekhar/drag-drop-api",
                date: "Jan 11, 2021",
                demo: "https://notshekhar.github.io/drag-drop-api",
                technologies: ["JavaScript", "CSS", "HTML"],
                type: "fed",
            },
        ],
    },
    {
        year: 2020,
        data: [
            {
                title: "Video Calling App updated",
                url: "https://github.com/notshekhar/Video-Calling-App-Upgrade",
                date: "Dec 12, 2020",
                demo: "https://papermeet.herokuapp.com/",
                technologies: [
                    "JavaScript",
                    "Node",
                    "WebRTC",
                    "peerjs",
                    "socket.io",
                    "express",
                    "ejs view-engine",
                    "CSS",
                    "HTML",
                ],
                type: "bed",
            },
            {
                title: "Snake Game",
                url: "https://github.com/notshekhar/Snake-Game-",
                date: "Dec 10, 2020",
                demo: "https://notshekhar.github.io/Snake-Game-",
                technologies: ["JavaScript", "HTMLCanvas"],
                type: "cc",
            },
            {
                title: "A bot to play tic-tac-toe game using Neural Network with tensorflow.js",
                url: "https://github.com/notshekhar/trained-tic-tac-toe-bot-using-neuralnework-tfjs",
                date: "Dec 07, 2020",
                technologies: ["node", "tensorflow.js", "NeuralNetwork"],
                type: "ml",
            },
            {
                title: "Node CLI app to initialize express server",
                url: "https://github.com/notshekhar/init-server",
                demo: "https://www.npmjs.com/package/init-express",
                date: "Nov 26, 2020",
                technologies: ["node", "javascript"],
                type: "cc",
            },
            {
                title: "Basic todo add using vuejs-v3",
                url: "https://github.com/notshekhar/simple-todo-app-using-vuejs-v3",
                demo: "https://5z6mu.sse.codesandbox.io/",
                date: "Nov 26, 2020",
                technologies: ["vuejs"],
                type: "fed",
            },
            {
                title: "Handpose using ML5.js",
                url: "https://github.com/notshekhar/handposeML5",
                demo: "https://notshekhar.github.io/handposeML5",
                date: "Nov 08, 2020",
                technologies: ["HTMLCanvas", "ml5.js", "tensorflow.js", "js"],
                type: "ml",
            },
            {
                title: "API for fetching IP address of device",
                url: "https://github.com/notshekhar/express_api_getIPAddress",
                demo: "https://peerip.glitch.me/",
                date: "Oct 21, 2020",
                technologies: ["node", "express", "nedb"],
                type: "bed",
            },
            {
                title: "E-Visiting Card using express, ejs and MySql",
                url: "https://github.com/notshekhar/eVisitingCard",
                date: "Oct 20, 2020",
                technologies: [
                    "html",
                    "js",
                    "css",
                    "node",
                    "express",
                    "ejs",
                    "MySql",
                ],
                type: "bed",
            },
            {
                title: "Video Calling App using WebRTC, socketio and express",
                url: "https://github.com/notshekhar/Video-Calling-App",
                date: "Oct 11, 2020",
                demo: "https://meetfriend.glitch.me",
                technologies: [
                    "html",
                    "js",
                    "css",
                    "node",
                    "socketio",
                    "WebRTC",
                    "ejs",
                ],
                type: "bed",
            },
            {
                title: "Simple text editor using window.showOpenFilePicker() API",
                url: "https://github.com/notshekhar/simple_text_editor/",
                date: "Oct 09, 2020",
                demo: "https://notshekhar.github.io/simple_text_editor",
                technologies: ["html", "js", "css"],
                type: "cc",
            },
            {
                title: "Smart Bees using genetic algorithm",
                url: "https://github.com/notshekhar/Smart-Bees",
                date: "Oct 07, 2020",
                demo: "https://notshekhar.github.io/Smart-Bees",
                technologies: ["html", "js", "genetic algo", "neural network"],
                type: "ml",
            },
            {
                title: "Conway-s-Game-of-Life-Simulation",
                url: "https://github.com/notshekhar/Conway-s-Game-of-Life-Simulation",
                date: "Sept 27, 2020",
                demo: "https://notshekhar.github.io/Conway-s-Game-of-Life-Simulation",
                technologies: ["html", "js"],
                type: "cc",
            },
            {
                title: "Chess Bot using stockfish.js engine",
                url: "https://github.com/notshekhar/chess_bot_using_stockfish.js",
                date: "Aug 23, 2020",
                demo: "https://notshekhar.github.io/chess_bot_using_stockfish.js",
                technologies: [
                    "html",
                    "css",
                    "js",
                    "stockfish.js",
                    "chess.js",
                    "chessboard.js",
                    "jQuery",
                ],
                type: "cc",
            },
            {
                title: "Beautiful Trigonometry Simulation",
                url: "https://github.com/notshekhar/BeautifulTrigonometry",
                date: "June 17, 2020",
                demo: "https://notshekhar.github.io/BeautifulTrigonometry",
                technologies: ["html", "css", "js", "canvas"],
                type: "cc",
            },
            {
                title: "Logo for drophope",
                url: "https://github.com/notshekhar/LogoDesigns/tree/master/drophope",
                date: "May 23, 2020",
                technologies: ["figma"],
                type: "ld",
            },
            {
                title: "Brainfuck interpreter in JS",
                url: "https://github.com/notshekhar/brainfuck_interpreter",
                date: "April 20, 2020",
                demo: "https://raw.githubusercontent.com/notshekhar/brainfuck_interpreter/master/download/brainfuck.exe",
                technologies: ["js", "nodejs"],
                type: "cc",
            },
            {
                title: "Enable key word auto completion after a few letters typed. Follow-up: How to rank the words if they are weighted by frequency",
                url: "https://github.com/notshekhar/auto_completion_by-frequency_of-words_searched",
                date: "April 19, 2020",
                demo: "https://notshekhar.github.io/auto_completion_by-frequency_of-words_searched",
                technologies: ["html", "css", "js", "scss"],
                type: "fed",
            },
            {
                title: "URL Shortener (shorte) using Express, Socketio, nedb",
                url: "https://github.com/notshekhar/url_shortener",
                date: "March 08, 2020",
                demo: "https://shorte.glitch.me/",
                technologies: [
                    "html",
                    "css",
                    "js",
                    "node",
                    "expressjs",
                    "socketio",
                    "nedb",
                    "bootstrap",
                ],
                type: "bed",
            },
            {
                title: "Front End Development competition in Technovation",
                url: "https://github.com/notshekhar/technovation_2020",
                date: "Feb 27, 2020",
                technologies: ["html", "css", "js"],
                type: "fed",
            },
            {
                title: "A very basic interpreter",
                url: "https://github.com/notshekhar/basic_interpreter",
                date: "Feb 08, 2020",
                type: "cc",
            },
            {
                title: "For a Timetable App",
                url: "https://github.com/notshekhar/LogoDesigns/blob/master/timetableApp",
                date: "Jan 21, 2020",
                type: "ld",
            },
        ],
    },
    {
        year: 2019,
        data: [
            {
                title: "Writtor - A Simple Note App using React Native and Redux",
                url: "https://github.com/notshekhar/writtor/",
                date: "Dec 30, 2019",
                demo: "https://play.google.com/store/apps/details?id=com.notshekhar.writtor",
                type: "fed",
            },
            {
                title: "Tic Tac Toe Game using JS",
                url: "https://github.com/notshekhar/tic_tac_toe_game_using_JS/",
                date: "Dec 22, 2019",
                demo: "https://notshekhar.github.io/tic_tac_toe_game_using_JS",
                type: "cc",
            },
            {
                title: "Robotics Cometition (Eyantra) used Convolutional Neural Network and A* shortest path finding algorithm to solve maze",
                url: "https://github.com/notshekhar/eyantra_2019-2020",
                date: "Dec 19, 2019",
                type: "cc",
            },
            {
                title: "Maze Generation with Recursive Backtrack Algorithm",
                url: "https://github.com/notshekhar/Maze_Generation_Recursive_Backtrack_Algorithm/",
                date: "Dec 17, 2019",
                demo: "https://notshekhar.github.io/Maze_Generation_Recursive_Backtrack_Algorithm",
                type: "cc",
            },
            {
                title: "Interactive Drawing with SketchRNN",
                url: "https://github.com/notshekhar/Interactive_Drawing_with_SketchRNN/",
                date: "Nov 11, 2019",
                demo: "https://notshekhar.github.io/Interactive_Drawing_with_SketchRNN",
                type: "ml",
            },
            {
                title: "Mechanical Mirror Using BodyPix tfjs",
                url: "https://github.com/notshekhar/mechanical_mirror_using_BodyPix_TFjs/",
                date: "Oct 26, 2019",
                demo: "https://notshekhar.github.io/mechanical_mirror_using_BodyPix_TFjs",
                type: "ml",
            },
            {
                title: "A* Path Finding Algorithm",
                url: "https://github.com/notshekhar/a_star_path_finding_algo/",
                date: "Oct 25, 2019",
                demo: "https://notshekhar.github.io/a_star_path_finding_algo",
                type: "cc",
            },
            {
                title: "CSS Facebook Logo Design",
                url: "https://github.com/notshekhar/CSS_Facebook_Logo/",
                date: "Oct 06, 2019",
                type: "ld",
            },
            {
                title: "CSS Google Logo Design",
                url: "https://github.com/notshekhar/CSS_Google_Logo/",
                date: "Sep 07, 2019",
                type: "ld",
            },
            {
                title: "Text Toxicity with TensorflowJS",
                url: "https://github.com/notshekhar/text-toxicity-using-tfjs/",
                date: "Aug 30, 2019",
                demo: "https://notshekhar.github.io/text-toxicity-using-tfjs",
                type: "ml",
            },
            {
                title: "Grey Code To Binary Generator",
                url: "https://github.com/notshekhar/grey_code_to_binary_generator/",
                date: "Aug 06, 2019",
                demo: "https://notshekhar.github.io/grey_code_to_binary_generator",
                type: "cc",
            },
            {
                title: "FoodApp which showcase the meal for the next 30 days using ReactJS",
                url: "https://github.com/notshekhar/foodapp/",
                date: "Aug 04, 2019",
                demo: "https://notshekhar-foodapp.glitch.me",
                type: "fed",
            },
            {
                title: "Visualization of Gift Wraping Algorithm",
                url: "https://github.com/notshekhar/gift_wrapping_algorithm/",
                date: "Jun 29, 2019",
                demo: "https://notshekhar.github.io/gift_wrapping_algorithm",
                type: "cc",
            },
            {
                title: "Calculating value of PI with Mandelbrot Set using Python",
                url: "https://github.com/notshekhar/PI_with_Mandelbrot_Set/",
                date: "Jun 28, 2019",
                type: "cc",
            },
            {
                title: "Color Train using NOOPS HEXBOT (#noopschallenge)",
                url: "https://github.com/notshekhar/hexbot/",
                date: "Jun 27, 2019",
                demo: "https://notshekhar.github.io/hexbot",
                type: "cc",
            },
            {
                title: "Genetic Algorithm To Automate Dinosaur Game and bundled all JS files using WEBPACK",
                url: "https://github.com/notshekhar/genetic_algorithm_to_automate_dinosaur_game/",
                date: "Jun 21, 2019",
                demo: "https://notshekhar.github.io/genetic_algorithm_to_automate_dinosaur_game",
                type: "ml",
            },
            {
                title: "Chrome Dinosaur Game",
                url: "https://github.com/notshekhar/dino_game/",
                date: "Jun 20, 2019",
                demo: "https://notshekhar.github.io/dino_game",
                type: "cc",
            },
            {
                title: "Personal Logo Design",
                url: "https://github.com/notshekhar/LogoDesigns/tree/master/personal/",
                date: "Jun 13, 2019",
                type: "ld",
            },
            {
                title: "Facebook Like Button Design",
                url: "https://github.com/notshekhar/facebook_like_button_design/",
                date: "Jun 13, 2019",
                demo: "https://notshekhar.github.io/facebook_like_button_design",
                type: "fed",
            },
            {
                title: "Encryption And Decryption App using AES Algorithm",
                url: "https://github.com/notshekhar/AES_Encryption_And_Decryption_App/",
                date: "Jun 12, 2019",
                demo: "https://notshekhar.github.io/AES_Encryption_And_Decryption_App",
                type: "cc",
            },
            {
                title: "WebAPIs: Broadcast Channel API",
                url: "https://github.com/notshekhar/WebAPIs/tree/master/BroadcastChannelAPI/",
                date: "Jun 06, 2019",
                demo: "https://notshekhar.github.io/WebAPIs/BroadcastChannelAPI",
                type: "fed",
            },
            {
                title: "WebAPIs: Battery API",
                url: "https://github.com/notshekhar/WebAPIs/tree/master/BatteryAPI/",
                date: "Jun 06, 2019",
                demo: "https://notshekhar.github.io/WebAPIs/BatteryAPI",
                type: "fed",
            },
            {
                title: "AES Symmetric Key Cryptography Algorithm in JavaScript",
                url: "https://github.com/notshekhar/AES-Symmetric-Key-Cryptography-algorithm/",
                date: "May 23, 2019",
                type: "cc",
            },
            {
                title: "KNN Classifier With KNN Library I've using JavaScript",
                url: "https://github.com/notshekhar/KNN-Classifier-With-KNN-Library-JavaScript/",
                date: "May 22, 2019",
                demo: "https://notshekhar.github.io/KNN-Classifier-With-KNN-Library-JavaScript",
                type: "ml",
            },
            {
                title: "KNN Library with JavaScript",
                url: "https://github.com/notshekhar/KNN-Library-with-JavaScript/",
                date: "May 21, 2019",
                type: "ml",
            },
            {
                title: "2D Ray Tracing",
                url: "https://github.com/notshekhar/RayTracing2D/",
                date: "May 20, 2019",
                demo: "https://notshekhar.github.io/RayTracing2D",
                type: "cc",
            },
            {
                title: "2D Ray Casting",
                url: "https://github.com/notshekhar/RayCasting2D/",
                date: "May 20, 2019",
                demo: "https://notshekhar.github.io/RayCasting2D",
                type: "cc",
            },
            {
                title: "YouTube bot to increase views with Puppeteer",
                url: "https://github.com/notshekhar/youtubebot/",
                date: "May 10, 2019",
                type: "cc",
            },
            {
                title: "Refactored 'BodyPix with tensorflow.js' using WebWorker",
                url: "https://github.com/notshekhar/bodyPixWithWebWorker/",
                date: "April 27, 2019",
                demo: "https://notshekhar.github.io/bodyPixWithWebWorker",
                type: "ml",
            },
            {
                title: "ToDo Application using React.js",
                url: "https://github.com/notshekhar/ToDo-App-using-React/",
                date: "April 18, 2019",
                demo: "https://csb-9j6v2y1zky.netlify.com/",
                type: "fed",
            },
            {
                title: "Body Pixels using Tensorflow.js",
                url: "https://github.com/notshekhar/bodyPix/",
                date: "April 08, 2019",
                demo: "https://notshekhar.github.io/bodyPix",
                type: "ml",
            },
            {
                title: "Sorting algorithm library in JavaScript",
                url: "https://github.com/notshekhar/sortingAgorithm/",
                date: "April 05, 2019",
                type: "cc",
            },
            {
                title: "Quick Sort Visualisation",
                url: "https://github.com/notshekhar/quicksort-visualisation//",
                date: "April 05, 2019",
                demo: "https://notshekhar.github.io/quicksort-visualisation/",
                type: "cc",
            },
            {
                title: "Image Filter using WebWorkers",
                url: "https://github.com/notshekhar/Image-Filter-using-WebWorkers/",
                date: "April 04, 2019",
                demo: "https://notshekhar.github.io/Image-Filter-using-WebWorkers",
                type: "fed",
            },
            {
                title: "Vector Library In JavaScript",
                url: "https://github.com/notshekhar/Vector-Library-in-JavaScript/",
                date: "March 20, 2019",
                type: "cc",
            },
            {
                title: "Approximating the Value of PI using Ruby",
                url: "https://github.com/notshekhar/Approximating-the-Value-of-PI-using-Ruby/",
                date: "March 19, 2019",
                type: "cc",
            },
            {
                title: "Approximating the Value of PI",
                url: "https://github.com/notshekhar/Approximating-the-Value-of-PI/",
                date: "March 19, 2019",
                demo: "https://notshekhar.github.io/Approximating-the-Value-of-PI",
                type: "cc",
            },
            {
                title: "Calculating Digits of PI with Collisions",
                url: "https://github.com/notshekhar/calculating-digits-of-pi-with-collisions/",
                date: "March 17, 2019",
                demo: "https://notshekhar.github.io/calculating-digits-of-pi-with-collisions",
                type: "cc",
            },
            {
                title: "Selection Sort Visualisation",
                url: "https://github.com/notshekhar/Selection-Sort-Visualisation/",
                date: "March 12, 2019",
                demo: "https://notshekhar.github.io/Selection-Sort-Visualisation",
                type: "cc",
            },
            {
                title: "KNN Classifier using ml5js library (a classifier like teachable machine)",
                url: "https://github.com/notshekhar/KNN-Classifier/",
                date: "March 01, 2019",
                demo: "https://notshekhar.github.io/KNN-Classifier/",
                type: "ml",
            },
            {
                title: "Scroll Bar Indictor",
                url: "https://github.com/notshekhar/Scroll-Bar-Indicator/",
                date: "Feb 21, 2019",
                demo: "https://notshekhar.github.io/Scroll-Bar-Indicator/",
                type: "fed",
            },
            {
                title: "A personal logo for my YouTube channel (notshekhar)",
                url: "https://github.com/notshekhar/LogoDesigns/tree/master/notshekhar",
                date: "Feb 21, 2019",
                type: "ld",
            },
            {
                title: "Visualisation of Heart Curve's Mathematical Equation using JavaScript and HTML5",
                url: "https://github.com/notshekhar/Heart-Curve",
                date: "Feb 19, 2019",
                demo: "https://notshekhar.github.io/Heart-Curve",
                type: "cc",
            },
            {
                title: "Bubble Sort Visualisation using JavaScript and HTML5",
                url: "https://github.com/notshekhar/LogoDesigns/tree/master/bubbleSortVisualisation",
                date: "Feb 05, 2019",
                demo: "https://notshekhar.github.io/bubbleSortVisualisation",
                type: "cc",
            },
            {
                title: "WebSite with SignUp/SignIn option using facebook graph api and expressjs server and mysql for data management",
                url: "https://github.com/notshekhar/LogoDesigns/tree/master/PlanetArcadia",
                date: "Feb 01, 2019",
                type: "bed",
            },
            {
                title: "Planet Arcadia (Fun and Game)",
                url: "https://github.com/notshekhar/LogoDesigns/tree/master/planet%20arcadia",
                date: "Jan 31, 2019",
                type: "ld",
            },
            {
                title: "Colliding Blocks simulation in space using HTML, CSS, and JavaScript",
                url: "https://github.com/notshekhar/collidingBlocks",
                date: "Jan 24, 2019",
                demo: "https://notshekhar.github.io/collidingBlocks/",
                type: "cc",
            },
            {
                title: "Ripple Button using HTML, CSS, and JavaScript",
                url: "https://github.com/notshekhar/rippleButton",
                date: "Jan 10, 2019",
                demo: "https://notshekhar.github.io/rippleButton/",
                type: "fed",
            },
            {
                title: "JavaScript Library which deals with HTML Dom and ajax",
                url: "https://github.com/notshekhar/JavaScript-libraries/tree/master/slasho",
                date: "Jan 6, 2019",
                type: "cc",
            },
            {
                title: "JavaScript Library which handels cookies",
                url: "https://github.com/notshekhar/cookies/",
                date: "Jan 6, 2019",
                demo: "https://notshekhar.github.io/cookies/demo",
                type: "cc",
            },
            {
                title: "Tetris Game in Canvas HTML5",
                url: "https://github.com/notshekhar/tetris/",
                date: "Jan 3, 2019",
                demo: "https://notshekhar.github.io/tetris",
                type: "cc",
            },
            {
                title: "Android Aplication (Flurr Note) using ReactNative and Expo",
                url: "https://snack.expo.io/@notshekhar/notes",
                date: "Jan 1, 2019",
                demo: "https://play.google.com/store/apps/details?id=com.flurr.notes",
                type: "fed",
            },
        ],
    },
    {
        year: 2018,
        data: [
            {
                title: "A personal logo for my new React Native Application",
                url: "https://github.com/notshekhar/LogoDesigns/Flurr%20Note/",
                date: "Dec 31, 2018",
                type: "ld",
            },
            {
                title: "StickMan Run Game using JavaScript",
                url: "https://github.com/notshekhar/stickmanRun",
                date: "Dec 31, 2018",
                demo: "https://notshekhar.github.io/stickmanRun/",
                type: "cc",
            },
            {
                title: "Drawing cat using doodle data with node.js ( used expressjs to setup the server )",
                url: "https://github.com/notshekhar/Drawing-cat-using-doodle-data-with-node.js-",
                date: "Dec 24, 2018",
                type: "bed",
            },
            {
                title: "MNIST Classifier using Convolutional Neural Network with TensorFlow.js",
                url: "https://github.com/notshekhar/convolutionalNeuralNetwork",
                date: "Dec 23, 2018",
                demo: "https://notshekhar.github.io/convolutionalNeuralNetwork/",
                type: "ml",
            },
            {
                title: "Custom HTML Video Element using JavaScript",
                url: "https://github.com/notshekhar/customElements/blob/master/slashoVideo.js",
                date: "Dec 23, 2018",
                type: "cc",
            },
            {
                title: "Fouries Series",
                url: "https://github.com/notshekhar/fouriesSeries",
                date: "Dec 21, 2018",
                demo: "https://notshekhar.github.io/fouriesSeries/",
                type: "cc",
            },
            {
                title: "AI learns to play Flappy Bird ( neuroevolution )",
                url: "https://github.com/notshekhar/neuroevolutionFlappyBird",
                date: "Dec 20, 2018",
                demo: "https://notshekhar.github.io/neuroevolutionFlappyBird/",
                type: "ml",
            },
            {
                title: "10Print pattern",
                url: "https://github.com/notshekhar/10Print",
                date: "Dec 19, 2018",
                demo: "https://notshekhar.github.io/10Print/",
                type: "cc",
            },
            {
                title: "Flappy Bird",
                url: "https://github.com/notshekhar/flappyBird",
                date: "Dec 18, 2018",
                demo: "https://notshekhar.github.io/flappyBird/",
                type: "cc",
            },
            {
                title: "2048 Game",
                url: "https://github.com/notshekhar/2048",
                date: "Dec 17, 2018",
                demo: "https://notshekhar.github.io/2048/",
                type: "cc",
            },
            {
                title: "For Mooover Enterprises",
                url: "https://github.com/notshekhar/LogoDesigns/tree/master/mooover",
                date: "Dec 14, 2018",
                type: "ld",
            },
            {
                title: "Simple Pendulum",
                url: "https://github.com/notshekhar/simple-pendulum",
                date: "Dec 12, 2018",
                demo: "https://notshekhar.github.io/simple-pendulum/",
                type: "cc",
            },
            {
                title: "PoseNet",
                url: "https://github.com/notshekhar/posenet",
                date: "Dec 09, 2018",
                demo: "https://notshekhar.github.io/posenet/",
                type: "ml",
            },
            {
                title: "Chrome Extension Changes text of whole page to the text entered in extension",
                url: "https://github.com/notshekhar/changes-all-p-element-text-to-th-text-entered-in-extension",
                date: "Oct 29, 2018",
                demo: "https://chrome.google.com/webstore/detail/hcehngpcajmihnplidpjolngfmlcpomk/publish-review",
                type: "fed",
            },
            {
                title: "Sticky Natigation Bar",
                url: "https://github.com/notshekhar/Sticky-Nav",
                date: "Oct 21, 2018",
                demo: "https://notshekhar.github.io/Sticky-Nav/",
                type: "fed",
            },
            {
                title: "Video Speed Controller",
                url: "https://github.com/notshekhar/Video-Speed-Controller",
                date: "Oct 20, 2018",
                demo: "https://notshekhar.github.io/Video-Speed-Controller/",
                type: "cc",
            },
            {
                title: "Yolo Detection using ml5js",
                url: "https://github.com/notshekhar/yolo-detection-using-ml5js",
                date: "Oct 10, 2018",
                demo: "https://notshekhar.github.io/yolo-detection-using-ml5js/",
                type: "ml",
            },
            {
                title: "Text to Speech",
                url: "https://github.com/notshekhar/Text-to-Speech",
                date: "Oct 9, 2018",
                demo: "https://notshekhar.github.io/Text-to-Speech/",
                type: "cc",
            },
            {
                title: "Color Predictor",
                url: "https://github.com/notshekhar/Color-Predictor",
                date: "Oct 8, 2018",
                demo: "https://notshekhar.github.io/Color-Predictor/",
                type: "ml",
            },
            {
                title: "Redesigned my university's admission cell website ( Gautam Buddha University )",
                url: "https://github.com/notshekhar/gbu",
                date: "Sep 24, 2018",
                demo: "https://notshekhar.github.io/gbu/",
                type: "fed",
            },
            {
                title: "LocalStorage and Event Delegation work",
                url: "https://github.com/notshekhar/LocalStorage-and-Event-Delegation-work",
                date: "Sep 8, 2018",
                demo: "https://notshekhar.github.io/LocalStorage-and-Event-Delegation-work/",
                type: "cc",
            },
            {
                title: "Custom HTML5 Video Player",
                url: "https://github.com/notshekhar/VideoPlayer",
                date: "Sep 8, 2018",
                demo: "https://notshekhar.github.io/VideoPlayer/",
                type: "cc",
            },
            {
                title: "Hold Shift and Check Checkboxes",
                url: "https://github.com/notshekhar/checkboxes",
                date: "Sep 8, 2018",
                demo: "https://notshekhar.github.io/checkboxes/",
                type: "cc",
            },
            {
                title: "Fun with HTML5 Canvas",
                url: "https://github.com/notshekhar/Canvas-Drawing",
                date: "Sep 7, 2018",
                demo: "https://notshekhar.github.io/Canvas-Drawing/",
                type: "cc",
            },
            {
                title: "Ajax Type Ahead with fetch()",
                url: "https://github.com/notshekhar/Ajax-Ahead",
                date: "Sep 6, 2018",
                demo: "https://notshekhar.github.io/Ajax-Ahead",
                type: "cc",
            },
            {
                title: "Flexbox + JavaScript Image Gallery",
                url: "https://github.com/notshekhar/FlexBox-JavaScript-Image-gallery",
                date: "Sep 6, 2018",
                demo: "https://notshekhar.github.io/FlexBox-JavaScript-Image-gallery",
                type: "cc",
            },
            {
                title: "Woah! CSS variables?! ( CSS variable updated by JavaScript )",
                url: "https://github.com/notshekhar/CSS-Variable",
                date: "Sep 3, 2018",
                demo: "https://notshekhar.github.io/CSS-Variable",
                type: "cc",
            },
            {
                title: "JavaScript+CSS Clock",
                url: "https://github.com/notshekhar/clock",
                date: "Sep 3, 2018",
                demo: "https://notshekhar.github.io/clock",
                type: "cc",
            },
            {
                title: "Drum Kit",
                url: "https://github.com/notshekhar/Drum-Kit",
                date: "Sep 2, 2018",
                demo: "https://notshekhar.github.io/Drum-Kit",
                type: "cc",
            },
            {
                title: "Slasho { codebeat }",
                url: "https://github.com/notshekhar/LogoDesigns/tree/master/slasho",
                date: "Aug 29, 2018",
                type: "ld",
            },
            {
                title: "Algorithms in JavaScript",
                url: "https://github.com/notshekhar/JavaScript-Algorithm",
                date: "Aug 21, 2018",
                type: "cc",
            },
            {
                title: "Teachable Machine ( pattern detecton using neural network library written in javaScript )",
                url: "https://github.com/notshekhar/teachable-machine",
                date: "Aug 20, 2018",
                demo: "https://notshekhar.github.io/teachable-machine",
                technologies: ["html", "css", "js", "neural network"],
                type: "ml",
            },
            {
                title: "Login and signup page using python flask and Javascript",
                url: "https://github.com/notshekhar/login-and-signup-page-using-python-flask",
                date: "Aug 15, 2018",
                technologies: ["python", "flask", "html", "css", "js"],
                type: "bed",
            },
            {
                title: "Hand written digit Recognisor using neuralnet lib written in JavasScript",
                url: "https://github.com/notshekhar/flurr",
                date: "Jul 18, 2018",
                demo: "https://notshekhar.github.io/flurr/",
                technologies: ["html", "css", "js", "neural network"],
                type: "ml",
            },
            {
                title: "Flurr Note ( PWA which allows to create notes )",
                url: "https://github.com/notshekhar/note",
                date: "Jul 5, 2018",
                demo: "https://notshekhar.github.io/note/",
                technologies: ["html", "css", "js"],
                type: "fed",
            },
            {
                title: "RNN text generate in JavaScript",
                url: "https://github.com/notshekhar/rnn_text_generate_js",
                date: "Jun 14, 2018",
                demo: "https://notshekhar.github.io/rnn_text_generate_js/",
                technologies: ["html", "js", "neural network"],
                type: "ml",
            },
            {
                title: "ml5js homepage demo",
                url: "https://github.com/notshekhar/ml5_homepage_demo",
                date: "Jun 8, 2018",
                demo: "https://notshekhar.github.io/ml5_homepage_demo/",
                technologies: ["html", "css", "js"],
                type: "ml",
            },
            {
                title: "animations_js ( animation using HTML, CSS, JavaScript )",
                url: "https://github.com/notshekhar/animations_js",
                date: "Jun 1, 2018",
                demo: "https://notshekhar.github.io/animations_js/bobo.htm",
                technologies: ["html", "css", "js"],
                type: "fed",
            },
            {
                title: "neuralnet ( multilayer neural network lib in JavaScript )",
                url: "https://github.com/notshekhar/neuralnet",
                date: "Apr 22, 2018",
                technologies: ["js"],
                type: "ml",
            },
            {
                title: "flur-web ( front end web design )",
                url: "https://github.com/notshekhar/flur-web",
                date: "Apr 8, 2018",
                demo: "https://notshekhar.github.io/flur-web/",
                technologies: ["html", "css"],
                type: "fed",
            },
            {
                title: "Designed Banner of Office Bearers for School",
                url: "https://www.canva.com/design/DAC3sdZW-YA/8P6BzYvTHGrv9oigquh6mw/view?utm_content=DAC3sdZW-YA&utm_campaign=designshare&utm_medium=link&utm_source=sharebutton",
                date: "May 30, 2018",
                technologies: ["canva.com"],
                type: "fed",
            },
            {
                title: "Neural_Network",
                url: "https://github.com/notshekhar/Neural-Network",
                date: "Mar 9, 2018",
                technologies: ["js"],
                type: "ml",
            },
            {
                title: "word2vec-js",
                url: "https://github.com/notshekhar/word2vec-js",
                date: "Feb 26, 2018",
                demo: "https://notshekhar.github.io/word2vec-js/",
                technologies: ["js"],
                type: "ml",
            },
        ],
    },
    {
        year: 2017,
        data: [
            {
                title: "For Tnsaino",
                url: "https://github.com/notshekhar/LogoDesigns/tree/master/tnsaino",
                date: "Dec 06, 2017",
                technologies: ["adobe photoshop"],
                type: "ld",
            },
            {
                title: "CSS Sprite Images",
                url: "https://www.github.com/notshekhar/notsurf",
                date: "Dec 12, 2017",
                demo: "https://notshekhar.github.io/notsurf",
                technologies: ["HTML", "CSS", "JavaScript", "PWA"],
                type: "fed",
                updated: "Feb 09, 2026",
                description:
                    "A PWA demonstrating CSS sprite optimization for reduced HTTP requests and improved load times.",
                detailSlug: "css-sprite-images",
            },
            {
                title: "NotSurf",
                url: "https://www.github.com/notshekhar/LogoDesigns/tree/master/notsurf",
                date: "Dec 11, 2017",
                technologies: ["html", "css"],
                type: "ld",
            },
            {
                title: "Just a Design",
                url: "https://www.github.com/notshekhar/school",
                date: "Jul 28, 2017",
                demo: "https://notshekhar.github.io/school",
                technologies: ["html", "css", "firebase", "js"],
                type: "fed",
            },
            {
                title: "Javascript Web Editor ( Runs HTML,CSS,JS codes )",
                url: "https://www.github.com/notshekhar/edit",
                date: "Jul 5, 2017",
                demo: "https://notshekhar.github.io/edit",
                technologies: ["html", "css", "jQuery"],
                type: "cc",
            },
            {
                title: "Calender Design",
                url: "https://www.canva.com/design/DACXIwo2tqE/tzNrw0Hnh6u4vOIYOCb4sQ/view?utm_content=DACXIwo2tqE&utm_campaign=designshare&utm_medium=link&utm_source=sharebutton",
                date: "Jun 23, 2017",
                technologies: ["canva.com"],
                type: "fed",
            },
            {
                title: "Flask Web Application",
                url: "https://github.com/notshekhar/flaspy",
                date: "Jun 4, 2017",
                technologies: ["python", "flask", "css", "html", "js"],
                type: "bed",
            },
            {
                title: "First every CSS page design I've designed",
                url: "https://www.github.com/notshekhar/answer",
                date: "Mar 30, 2017",
                demo: "https://notshekhar.github.io/answer",
                technologies: ["html", "css"],
                type: "fed",
            },
            {
                title: "Designed Banner of Office Bearers for School",
                url: "https://www.canva.com/design/DACUDnoIUUE/bIL0Xf_Vr5KBjxN0KgiURw/view?utm_content=DACUDnoIUUE&utm_campaign=designshare&utm_medium=link&utm_source=sharebutton",
                date: "May 27, 2017",
                technologies: ["canva.com"],
                type: "fed",
            },
        ],
    },
]

// Flatten the year-grouped structure into a flat array with consistent fields
function flattenProjects(data) {
    const flatProjects = []

    for (const yearGroup of data) {
        for (const project of yearGroup.data) {
            // Generate a consistent slug from the title
            const slug =
                project.detailSlug ||
                project.title
                    .toLowerCase()
                    .replace(/[^a-z0-9\s-]/g, "")
                    .replace(/\s+/g, "-")
                    .replace(/-+/g, "-")
                    .trim()

            flatProjects.push({
                slug,
                title: project.title,
                date: project.date,
                updated: project.updated || project.date,
                github: project.url || null,
                demo: project.demo || null,
                technologies: project.technologies || [],
                type: project.type || "cc",
                status: "completed",
                description: project.description || null,
                detailSlug: project.detailSlug || null,
                detailsIncluded: !!project.detailSlug,
            })
        }
    }

    // Sort by date (newest first)
    return flatProjects.sort((a, b) => {
        const parseDate = (dateStr) => {
            if (!dateStr) return new Date(0)
            if (dateStr.includes("-")) return new Date(dateStr)
            return new Date(dateStr)
        }
        return parseDate(b.date) - parseDate(a.date)
    })
}

export const projects = flattenProjects(projectsRaw)

// Helper to get project by slug
export function getProjectBySlug(slug) {
    return projects.find((p) => p.slug === slug || p.detailSlug === slug)
}

// Helper to get all unique technologies
export function getAllTechnologies() {
    const techSet = new Set()
    projects.forEach((p) => p.technologies.forEach((t) => techSet.add(t)))
    return Array.from(techSet).sort()
}
